import React from "react";
import { Button } from "@/components/ui/button";
import { TooltipWithContent } from "@/components/ui/tooltip";
import { ChevronUp, ChevronDown } from "lucide-react";

interface DetailModalNavigationButtonsProps {
  orientation: "horizontal" | "vertical";
  tooltipPosition: "top" | "right";
  canGoPrevious: boolean;
  canGoNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export function DetailModalNavigationButtons({
  orientation,
  tooltipPosition,
  canGoPrevious,
  canGoNext,
  onPrevious,
  onNext,
}: DetailModalNavigationButtonsProps) {
  const containerClass =
    orientation === "horizontal"
      ? "flex items-center gap-1"
      : "flex flex-col items-center gap-1";

  return (
    <div className={containerClass}>
      <TooltipWithContent content="Previous" position={tooltipPosition}>
        <Button
          variant="outline"
          size="sm"
          onClick={onPrevious}
          disabled={!canGoPrevious}
          className="p-2"
        >
          <ChevronUp className="h-4 w-4" />
        </Button>
      </TooltipWithContent>
      <TooltipWithContent content="Next" position={tooltipPosition}>
        <Button
          variant="outline"
          size="sm"
          onClick={onNext}
          disabled={!canGoNext}
          className="p-2"
        >
          <ChevronDown className="h-4 w-4" />
        </Button>
      </TooltipWithContent>
    </div>
  );
}
